var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeBig = function SvgHomeBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#home-big_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CED3D8",
    d: "M.909 17.272A2.86 2.86 0 0 0 0 19.36v16.354A4.286 4.286 0 0 0 4.286 40h31.428A4.285 4.285 0 0 0 40 35.714V19.36a2.86 2.86 0 0 0-.909-2.088L20.93.343a1.43 1.43 0 0 0-1.858 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#808A93",
    d: "M19.286 25h5.008V16.43h-8.571V25zM13.56 36.43h5.011v-8.572H10v8.572zm11.491 0H21.43v-8.572H30v8.572h-4.949"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "home-big_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
};
export default SvgHomeBig;